import gql from 'graphql-tag';

export const COLUMN_PRODUCT_FRAGMENT = gql`
    fragment ColumnProduct on ColumnProduct {
        productId
        product {
            _id
            fullname
            state
            flow
        }
        lastColumnInventoryStock {
            _id
            value
            createdAt
            createdBy
            createdByName
        }
        targetStock
        stock
        availableStock {
            isUnlimited
            value
            details {
                dailyStocks
                orderedStocks
                realRecurringOrders
                predictionRecurringOrders
                realPunctualOrders
                predictionPunctualOrders
                realStoreTargetNotPrepared
                realStoreTargetPrepared
                predictionStoreTarget
                storeMenu
                preparationDate
                preparationDateUsedIndex
                soonestRestockedDate
                soonestRestockedDateUsedIndex
                usedRecurringOrders
                usedPunctualOrders
                usedStoreTarget
                usedStoreMenu
            }
        }
        variations {
            _id
            createdAt
            delta
            type
            ref
            explanation
            columnInventoryStockId
        }
        inventories {
            _id
            createdAt
            createdBy
            createdByName
            type
            value
            previousColumnInventoryStockId
            modifierId
        }
    }
`;

export const COLUMN_PRODUCT_LIGHT_FRAGMENT = gql`
    fragment ColumnProductLight on ColumnProduct {
        productId
        product {
            _id
            fullname
            state
            flow
        }
        lastColumnInventoryStock {
            _id
            value
            createdAt
        }
        targetStock
        stock
        merchantValuation
        availableStock {
            isUnlimited
            value
        }
        latestStockVariations {
            _id
            createdAt
            delta
            type
            ref
            explanation
            columnInventoryStockId
        }
    }
`;
